import { lazy } from 'react';
export const ActionItemList = lazy(() =>
  import('./pages/action_items/ActionItemList.jsx'),
);
export const Audits = lazy(() => import('./pages/audit/Audits.jsx'));
export const CPAPage = lazy(() => import('./pages/audit/CPAPage.jsx'));
export const CountPage = lazy(() =>
  import('./pages/analytics/count_analytics/CountPage.jsx'),
);
export const Observations = lazy(() =>
  import('./pages/observations/Observations.jsx'),
);
export const ObservationPage = lazy(() =>
  import('./pages/observations/ObservationPage.jsx'),
);
export const Toolbox = lazy(() => import('./pages/toolbox_talks/Toolbox.jsx'));
export const ToolboxTalkGenerator = lazy(() =>
  import('./pages/toolbox_talks/ToolboxTalkGenerator.jsx'),
);
export const Announcements = lazy(() =>
  import('./pages/announcements/Announcements.jsx'),
);
export const Analytics = lazy(() => import('./pages/analytics/Analytics.jsx'));
export const Timecards = lazy(() => import('./pages/hr/Timecards.jsx'));
export const AddTimecard = lazy(() => import('./pages/hr/AddTimecard.jsx'));
export const Expense = lazy(() => import('./pages/hr/Expense.jsx'));
export const Expenses = lazy(() => import('./pages/hr/Expenses.jsx'));
export const WorkspaceDetailsPage = lazy(() =>
  import('././pages/workspace/WorkspaceDetailsPage.jsx'),
);
export const VehiclesPage = lazy(() =>
  import('./pages/fleet/VehiclesPage.jsx'),
);
export const SettingsTabSystem = lazy(() =>
  import('./pages/SettingsTabSystem.jsx'),
);
export const Incidents = lazy(() => import('./pages/incidents/Incidents.jsx'));
export const IncidentReport = lazy(() =>
  import('./pages/incidents/IncidentReport.jsx'),
);
export const FilesPage = lazy(() => import('./pages/files/FilesPage.jsx'));
export const CreateVehicle = lazy(() =>
  import('./pages/fleet/CreateVehicle.jsx'),
);
export const CreateQuestions = lazy(() =>
  import('./pages/fleet/CreateQuestions.jsx'),
);
export const VehicleDetailsPage = lazy(() =>
  import('./pages/fleet/VehicleDetailsPage.jsx'),
);
export const Tasks = lazy(() => import('././pages/Tasks/Tasks.jsx'));
export const UserProfile = lazy(() => import('./pages/user/UserProfile.jsx'));
export const CheckInList = lazy(() =>
  import('./pages/check_in_list/CheckInList.jsx'),
);

export const RiskRegistry = lazy(() =>
  import('./pages/risk_registry/RiskRegistry.jsx'),
);
export const Certifications = lazy(() =>
  import('./pages/role_requirement/Certifications.jsx'),
);
export const UserList = lazy(() => import('./pages/hr/users/UsersTabs.jsx'));
export const ScorecardPage = lazy(() =>
  import('./pages/scorecard/ScorecardPage.jsx'),
);
export const PermissionsAdminPage = lazy(() =>
  import('./pages/permissions/PermissionsAdminPage.jsx'),
);
